import styled from "styled-components";

export const CriarSolicitacaoBtn = styled.button`
  width: 45%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: ${(props) =>
    props.border && !props.disabled ? `2px solid ${props.color}` : "none"};
  cursor: pointer;
  transition: 0.3s;
  background-color: ${(props) => (props.border ? "#ffffff" : props.bg)};
  color: ${(props) => props.color || "#ffffff"};
  font-weight: bold;
  font-size: 22px;
  border-radius: 4px;
  margin-top: ${(props) => props.margin};
  &:hover {
    box-shadow: 0px 0px 8px ${(props) => props.bg};
  }

  &:disabled {
    cursor: auto;
    color: #848484;
    // border: 2px solid #d1d1d1;
    background-color: #d1d1d1;
    &:hover {
      box-shadow: none;
    }
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
